import React, { useEffect, useState } from "react";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { fetchAllPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { endpoint } from "views/pages/manage/common/constant";
// export const CASHIER_OFFICE_URL =
//   endpoint?.businessArea?.getCashierOfficeDetails;
export const DIGITAL_BUSINESS_IDS = ["IC006", "DW005", "DW007"];

const useCashierOfficeDropdown = ({
  label = "Cashier Office",
  defaultValue = null,
  placeholder = "Cashier Office",
  formHandler,
  inputHeight,
  businessArea = [],
  cashierOffice,
  isReadMode = false,
  labelStyle = {},
  customStylesUpdate = {},
  setCashierList = () => {},
  isMulti = false,
  isShowCount = false,
  isCharges = false,
  currentBusinessArea,
}) => {
  const [items, setItems] = useState([]);
  const [selected, setSelected] = useState(defaultValue);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    defaultValue && setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    if (cashierOffice && items.length > 0) {
      const currentOption = items.find((item) => item?.label === cashierOffice);
      if (currentOption) {
        setSelected(currentOption);
      }
    }
  }, [cashierOffice, items]); // Trigger this effect when cashierOffice or items change
  useEffect(() => {
    if (isCharges) {
      !isReadMode && setDisabled(false);
      if (
        Array.isArray(currentBusinessArea) &&
        currentBusinessArea.length > 0 &&
        !DIGITAL_BUSINESS_IDS.includes(currentBusinessArea[0]?.label)
      ) {
        setDisabled(true);
      }
      return;
    }

    if (Array.isArray(businessArea) ? !businessArea.length : !businessArea) {
      setDisabled(true);
      return;
    }


    let currentBu = Array.isArray(businessArea) ? businessArea[0]?.label : businessArea?.label;
    const allowed = DIGITAL_BUSINESS_IDS.includes(currentBu);
    if (allowed) {
      setDisabled(false);
      formHandler("cashierOffice", null);
      setSelected(null);
    } else {
      setDisabled(true);
      // in case of other cashier office is same as business area
      const selectedBu = { label: currentBu, value: currentBu };
      formHandler("cashierOffice", selectedBu);
      setSelected(selectedBu);
    }
  }, [businessArea]);

  useEffect(() => {
    const fetchOffices = async () => {
      setLoading(true);
      try {
        const data = await fetchAllPromisedData(endpoint?.businessArea?.getCashierOfficeDetails);
        //const data = [];
        if (Array.isArray(data)) {
          const transformed = data.map((item) => ({
            label: item?.businessAreaDispValue,
            value: item?.businessAreaDispValue,
            raw: item,
          }));
          setItems(transformed);
          if (setCashierList) {
            setCashierList(data);
          }
        } else {
          console.log("Invalid response format for cashier office list.");
        }
      } catch (error) {
        console.log("Failed to load cashier office list.");
      } finally {
        setLoading(false);
      }
    };
    fetchOffices();
  }, []);
  // while single select we will check is logged user has access this cashier office
  const validateCashierOfficeAccess = (students, key = "studentPaymentDetailsSearchResponseDTOS") => {
    // Ensure we always work with an array
    const studentList = Array.isArray(students[key]) ? students[key] : [students];
    return studentList.filter(student => {
      const currentStudent = student;

      if (!currentStudent) return true; // If no data, consider accessible
  
      const { businessAreaDispVal, chargesStatus, cashierOffice } = currentStudent;
  
      if (DIGITAL_BUSINESS_IDS.includes(businessAreaDispVal) && chargesStatus !== "PROV") {
        return items.some((item) => item?.label === cashierOffice);
      }
  
      return true; // Accessible by default
    });
  };

  const DropdownComponent =
    Array.isArray(currentBusinessArea) &&
    isCharges && 
    currentBusinessArea.length > 0 &&
    !DIGITAL_BUSINESS_IDS.includes(currentBusinessArea[0]?.label) ? (
      <div class="form-group">
        <label class="form-control-label">Cashier office </label>
        <h3>{cashierOffice}</h3>
      </div>
    ) : (
      <AAutoComplete
        label={label}
        items={items}
        currentValue={selected}
        handleChange={(newVal) => {
          formHandler("cashierOffice", newVal);
          setSelected(newVal);
        }}
        placeholder={placeholder}
        loading={loading}
        height={inputHeight}
        isDisabled={disabled || isReadMode}
        isMulti={isMulti}
        isShowCount={isShowCount}
        labelStyle={labelStyle}
        customStylesUpdate={customStylesUpdate}
      />
    );

  return { DropdownComponent, items, selected, validateCashierOfficeAccess, disabled };
};

export default useCashierOfficeDropdown;
